import React from 'react';
import { Route, Switch } from 'react-router';
import universal from '@nerdwallet/coin/universal';
import _ from 'lodash';
import { preloadIdentity } from '@nerdwallet/js-auth-tools/actions';
import {
  AnalyticsPageView,
  AnalyticsProvider,
} from '@nerdwallet/seo-analytics';

import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Container from './container';
import ConfigPage from '../containers/config-page/config-page';
import { loadConfigRoute } from '../lib/route-utils';

const BuilderContainer = universal(import('../containers/builder/container'));

export const BUILDER_SLUG = 'builder';

const dataDependencies = [
  {
    path: '/',
    loadData: async (opts, callback) => {
      const { store, req, res } = opts;
      store.dispatch(preloadIdentity(res.locals.data, req, res));

      await loadConfigRoute(opts);

      callback();
    },
  },
];

const analyticsWrapper = ({ children, flatOutline }) => {
  const pageConfig = _.filter(
    flatOutline,
    (component) => component.type === 'Page'
  )[0];
  const contentId = pageConfig?.contentId;
  return (
    <AnalyticsProvider>
      <AnalyticsPageView
        name="page_view"
        contentSource="wp"
        contentId={contentId}
      >
        {children}
      </AnalyticsPageView>
    </AnalyticsProvider>
  );
};

const ComposedAnalyticsWrapper = connect(
  createStructuredSelector({
    flatOutline: (state) => state?.builder?.flatOutline,
  })
)(analyticsWrapper);

const appFrom = (Component) => () =>
  (
    <ComposedAnalyticsWrapper>
      <Container>
        <Component />
      </Container>
    </ComposedAnalyticsWrapper>
  );

export default (
  <Switch dataDependencies={dataDependencies}>
    <Route path={`/l/${BUILDER_SLUG}`} component={appFrom(BuilderContainer)} />
    <Route path="/" component={appFrom(ConfigPage)} />
  </Switch>
);
